import { required, optional } from 'AppReact/schema';

export const person = {
  id: required('integer'),
  person_id: required('integer'),
  icon_url: optional('string'),
  phone_number: optional('string'),
  email: optional('string'),
  type: required('string'),
  name: required('string'),
}